import React, { useState, useEffect } from "react";
import momentTz from "moment-timezone"
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-typeahead/css/Typeahead.css";

import {
  Container,
  Row,
  Col,
  Table,
  ListGroup,
  Badge,
  Button,
} from "react-bootstrap";
import { useTable, useExpanded } from "react-table";

import { useDispatch, useSelector } from "react-redux";
import TimelinePicker from "../../../containers/TimeLinePicker/TimeLinePicker";
// import { useHistory } from 'react-router-dom';
import styles from "./Dashboard.module.css";
import { newAlert } from "../../../Slices/alertSlice";
import {
  getDashboardByTimePeriod,
  editCandidate,
} from "../../../Slices/orgAdminSlice";
import { formatDuration, calculateDateRange } from "./../../../helpers/stubs";
import { showModal, selectCandidate } from "../../../Slices/sessionSlice";
import { changeSelectedDay } from "../../../Slices/candidateSlice";
import SupervisorsEditModal, {
  id as supervisorEditId,
} from "../../../components/SupervisorsEditModal/SupervisorsEditModal";
import EditCandidateModal from "../../../components/EditCandidateModal/EditCandidateModal";
import CreateProject, {
  id as createProjectId,
} from "../../../components/CreateProject/CreateProject";
import EditProject, {
  id as editProjectId,
} from "../../../components/EditProject/EditProject";
import CandidateSearchBar from "../../../components/CandidateSearchBar/CandidateSearchBar";
import moment from "moment";
import Loading from "../../../components/Loading/Loading";
import { useNavigate } from "react-router-dom";

const EditUserModalId = "EditUser.edit";
function Dashboard() {
  // const [editCandidate, setEditCandidate] = React.useState(false);
  // const [editCandidatePayload, setEditCandidatePayload] = React.useState({});

  const { dashboard, loading } = useSelector((state) => state.orgAdminSlice);
  const {
    fromDate,
    toDate,
    activeModal,
    sessionUser: { timezone },
  } = useSelector((state) => state.sessionSlice);
  const clientId = "61dbf3b281b7744240053d7f";

  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    // Use timezone-aware date calculation instead of UTC
    const { from, to } = calculateDateRange("this week", timezone);
    const fromDate = from.toISOString();
    const toDate = to.toISOString();
    dispatch(
      getDashboardByTimePeriod({ clientId, fromDate, toDate, timezone })
    );
  }, [dispatch, timezone]);

  useEffect(() => {
    console.log("fromDate,toDate changed", fromDate, toDate);
    if (fromDate && toDate) {
      dispatch(
        getDashboardByTimePeriod({
          clientId,
          fromDate: fromDate,
          toDate: toDate,
          timezone,
        })
      );
    }
  }, [dispatch, fromDate, toDate, timezone]);

  const data = React.useMemo(() => {
    return dashboard.map((dashboardData, index) => {
      const {
        hourlyRate,
        activityPercentage,
        totalDuration,
        offline,
        tracker,
        candidateFirstName,
        candidateLastName,
        supervisors,
        organization,
        candidateId,
        position,
        userId,
        role,
        candidatesSupervising,
      } = dashboardData;
      console.log("dashboardData :- ", dashboardData);
      return {
        tracker: (
          <p className="align-middle text-center">
            {formatDuration(Math.ceil(tracker))}
          </p>
        ),
        offline: (
          <p className="align-middle text-center">{formatDuration(offline)}</p>
        ),
        position: (
          <>
            <p className="align-middle text-center">{position}</p>
          </>
        ),
        role: (
          <>
            <p className="align-middle text-center">{role}</p>
          </>
        ),
        totalDuration: (() => {
          const candidateName = `${candidateFirstName}**${candidateLastName}`;
          return (
            <>
              <div className="text-center">
                <p className="">
                  {formatDuration(Math.ceil(totalDuration))}{" "}
                  <Badge
                    pill
                    bg="secondary"
                    onClick={() => {
                      // Use fromDate to ensure consistency with the URL date parameter
                      const dateInTimezone = momentTz(fromDate).tz(timezone);
                      const startOfDayInTimezone = dateInTimezone.clone().startOf('day');
                      dispatch(changeSelectedDay(startOfDayInTimezone.toISOString()));
                      
                      dispatch(
                        selectCandidate({
                          userId,
                          candidateId,
                          candidateName: `${candidateFirstName} ${candidateLastName}`,
                        })
                      );
                      const date = momentTz(fromDate).tz(timezone).format('YYYY-MM-DD');
                      window.open(`/candidateScreenshots?candidateId=${candidateId}&&name=${candidateName.replace(/\s/g, "")}&&date=${date}`, '_blank');
                    }}
                    style={{ fontSize: "10px", cursor: "pointer" }}
                  >
                    screenshots
                  </Badge>
                </p>
              </div>
            </>
          );
        })(),
        activity: <p className="text-center">{`${activityPercentage > 95 ? 95 : activityPercentage} %`}</p>,
        hourlyRate: (
          <p className="align-middle text-center">{`$ ${hourlyRate}`}</p>
        ),
        supervisors:
          supervisors.length > 0 ? (
            <div>
              <ul>
                {supervisors.map((supervisor, key) => {
                  return (
                    <li key={key}>
                      <p>{`${supervisor.firstName} ${supervisor.lastName}`}</p>
                    </li>
                  );
                })}
              </ul>
            </div>
          ) : (
            "none"
          ),
        candidatesSupervising:
          candidatesSupervising.length > 0 ? (
            <div>
              <ul>
                {candidatesSupervising.map((candidate, key) => {
                  return (
                    <li key={key}>
                      <p>{`${candidate.firstName} ${candidate.lastName}`}</p>
                    </li>
                  );
                })}
              </ul>
            </div>
          ) : (
            "none"
          ),
        candidateName: (
          <>
            <span
              className="mr-4"
              // style={{ cursor: "pointer" }}
              // onClick={() => {
              //   dispatch(
              //     selectCandidate({
              //       userId,
              //       candidateId,
              //       candidateName: `${candidateFirstName} ${candidateLastName}`,
              //     })
              //   );
              //   const date = momentTz(fromDate).tz(timezone).format('YYYY-MM-DD');
              //   navigate(`/candidateScreenshots?date=${date}` , { replace: true });
              // }}
            >
              {`${candidateFirstName} ${candidateLastName}      `}
            </span>
            <span className="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="blue"
                className="mr-2 bi bi-pencil-square"
                viewBox="0 0 16 16"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  // setEditCandidatePayload({
                  //   candidateId,
                  //   supervisors: supervisors,
                  //   firstName: candidateFirstName,
                  //   lastName: candidateLastName,
                  // });
                  // setEditCandidate(true);

                  // dispatch(
                  //   showModal({
                  //     id: supervisorEditId,
                  //     data: { supervisors, candidateId, index, position },
                  //   })
                  // );
                  dispatch(
                    showModal({
                      id: EditUserModalId,
                      data: {
                        name: candidateFirstName + " " + candidateLastName,
                        _id: candidateId,
                        candidatesSupervisingOld: candidatesSupervising,
                        supervisorsOld: supervisors,
                        positionOld: position,
                        organization,
                        sessionUserRole: "OrgAdmin",
                        editCandidate,
                        role,
                        CandidateSearchBar,
                      },
                    })
                  );
                }}
              >
                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                <path
                  fillRule="evenodd"
                  d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                />
              </svg>
            </span>
          </>
        ),
      };
    });
  }, [dashboard, fromDate, timezone, dispatch, navigate]);
  const columns = React.useMemo(
    () => [
      {
        Header: "Candidates",
        accessor: "candidateName",
      },
      {
        Header: "Position",
        accessor: "position",
        width: 70,
      },
      {
        Header: "Role",
        accessor: "role",
        width: 50,
      },
      {
        Header: "Supervisors",
        accessor: "supervisors",
        width: 220,
      },
      {
        Header: "CandidatesSupervising",
        accessor: "candidatesSupervising",
        width: 200,
      },
      {
        Header: "Hours Tracked by Tracker",
        accessor: "tracker",
      },
      {
        Header: "Hours NOT Tracked by Tracker",
        accessor: "offline",
        width: 120,
      },
      {
        Header: "Total Hours Spent",
        accessor: "totalDuration", // accessor is the "key" in the data
        width: 200,
      },
      {
        Header: "Activity",
        accessor: "activity",
        width: 40,
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, useExpanded);

  return (
    <>
      <Container fluid={"lg"}>
        <Row className={"my-4 shadow-sm p-3 mb-5 bg-body rounded"}>
          <TimelinePicker  />
        </Row>
      </Container>
      {loading ? (
        <Loading />
      ) : (
        <Row className={"my-4 shadow-sm p-3 mb-5 bg-body rounded text-center"}>
          <Table {...getTableProps()} bordered responsive>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps({
                        style: {
                          minWidth: column.minWidth,
                          width: column.width,
                        },
                      })}
                    >
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row, i) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Row>
      )}
      {/* <Button
        variant="outline-primary"
        onClick={() =>
          dispatch(
            showModal({
              id: createProjectId,
              data: { clientId },
            })
          )
        }
      >
        Create Project
      </Button>

      <Button
        variant="outline-primary"
        onClick={() =>
          dispatch(
            showModal({
              id: editProjectId,
            })
          )
        }
      >
        Edit Project
      </Button> */}

      {/* {editCandidate && <EditCandidatePopUp />} */}
      {Boolean(activeModal) && activeModal.id === supervisorEditId && (
        <SupervisorsEditModal data={activeModal.data} />
      )}
      {Boolean(activeModal) && activeModal.id === EditUserModalId && (
        <EditCandidateModal data={activeModal.data} />
      )}
      {/* {Boolean(activeModal) && activeModal.id === createProjectId && (
        <CreateProject data={activeModal.data} />
      )}
      {Boolean(activeModal) && activeModal.id === editProjectId && (
        <EditProject data={activeModal.data} />
      )} */}
    </>
  );
}

export default Dashboard;
